import React from 'react';
import SecondaryButton from '../../../Buttons/SecondaryButton';

export default class BusinessLicenseApplicationIndex extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log('BusinessLicenseApplicationIndex', this.props);
		return (
			<div className="BusinessLicenseApplicationIndex pb-4">
				<div className="grid grid-cols-1">
					<div>
						<h1 className="text-2xl pb-4">
							Let's gather the info we need to apply for your business
							license...
						</h1>
						<div className="grid">
							<div className="lg:justify-self-end mb-4 lg:mb-0">
								<SecondaryButton
									label="Continue"
									onClick={this.props.continueLocation}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
